export enum PdfInvoiceType {
  Invoice = 0,
  InvoiceDeliveryFormStatement = 1,
  InvoiceAndInvoiceDeliveryFormStatement = 2,
  InvoiceWithParams = 3,
}
